import {
  Box,
  Button,
  Card,
  CardActions,
  CardContent,
  CardHeader,
  Divider,
  TextField,
  Unstable_Grid2 as Grid,
} from '@mui/material';
import { useSelector } from 'react-redux';

export const AccountProfileDetails = () => {
  const user = useSelector((store: any) => store.auth.user);

  return (
    <form autoComplete='off' noValidate>
      <Card>
        <CardHeader subheader='The information can be edited' title='Profile' />
        <CardContent sx={{ pt: 0 }}>
          <Box sx={{ m: -1.5 }}>
            <Grid container spacing={3}>
              <Grid xs={12} md={6}>
                <TextField
                  fullWidth
                  // helperText='Please specify the first name'
                  label='Name'
                  name='name'
                  InputLabelProps={{ shrink: true }}
                  // onChange={handleChange}
                  required
                  disabled
                  value={user.name}
                />
              </Grid>

              <Grid xs={12} md={6}>
                <TextField
                  fullWidth
                  label='Email Address'
                  name='email'
                  InputLabelProps={{ shrink: true }}
                  // onChange={handleChange}
                  required
                  disabled
                  value={user.email}
                />
              </Grid>
            </Grid>
          </Box>
        </CardContent>
        <Divider />
        <CardActions sx={{ justifyContent: 'flex-end' }}>
          <Button variant='contained' disabled>
            Save details
          </Button>
        </CardActions>
      </Card>
    </form>
  );
};
